import { IChecklistField, IChecklist } from '../../..'
import { IFormulaQuestion, IFormulaRowItem } from '../../../models/Formula'

function findChecklistFieldById(
  fieldId: number | undefined,
  groupId: number | undefined,
  checklist: IChecklist
): IChecklistField | undefined {
  if (groupId) {
    const group = checklist.groups.find((g) => g.id === groupId)
    if (!group) {
      return undefined
    }

    return group.fields.find((field) => field.id === fieldId)
  } else {
    for (const group of checklist.groups) {
      for (const field of group.fields) {
        if (field.id === fieldId) {
          return field
        }
      }
    }
  }
  return undefined
}
export function updateFormulaQuestionInDDL(
  inputQuestion: IChecklistField,
  ddlRowQuestions: IChecklistField[]
): void {
  if (!inputQuestion.formulaQuestions) {
    return
  }
  inputQuestion.formulaQuestions.forEach((formulaQ: IFormulaQuestion) => {
    const formulaQuestion = ddlRowQuestions.find(
      (i) => i.id === formulaQ.questionId
    )
    const foundQuestion = formulaQuestion!.formula!.inputQuestions.find(
      (i) => i.questionId === inputQuestion.id
    )
    if (foundQuestion) {
      foundQuestion.questionValue = inputQuestion.value as string
    }

    if (!inputQuestion.value) {
      // deselect answer, we need to reset the formula questions
      formulaQuestion!.value = ''
    } else if (
      formulaQuestion!.formula!.inputQuestions.every(
        (i) => i.questionValue !== undefined && i.questionValue !== ''
      )
    ) {
      const inputQuestionsMap = new Map<number, string>()
      formulaQuestion!.formula!.inputQuestions.forEach((i) => {
        inputQuestionsMap.set(i.questionId, i.questionValue!)
      })

      const foundMatchingRows = false

      // all input questions are answered, lets set the answer for the formula question
      for (const row of formulaQuestion!.formula!.formulaRows) {
        const rowMatches = row.formulaRowItems.every(
          (rowItem: IFormulaRowItem) => {
            const actualValue = inputQuestionsMap.get(rowItem.questionId)

            return actualValue && actualValue === rowItem.value
          }
        )

        if (rowMatches) {
          // conditions are met, lets set the answer for formula question
          if (row.resultAnswer !== formulaQuestion!.value) {
            formulaQuestion!.value = row.resultAnswer
          }
          return
        }
      }
      if (!foundMatchingRows && formulaQuestion!.value) {
        // formula question was answered but input question changed, lets reset the answer

        formulaQuestion!.value = ''
      }
    }
  })
}

export function getExpectedAnswerForFormulaQuestion(
  inputQuestion: IChecklistField,
  ddlQuestion: IChecklistField | undefined,
  checklist: IChecklist
): IFormulaQuestion[] {
  const formulaQuestionsToRefresh: IFormulaQuestion[] = []

  if (!inputQuestion.formulaQuestions) {
    return formulaQuestionsToRefresh
  }
  if (ddlQuestion) {
    // formula is in DDL
    return []
  } else {
    const newInputQuestionAnswer = inputQuestion.value as string

    inputQuestion.formulaQuestions.forEach((formulaQ: IFormulaQuestion) => {
      const formulaQuestion = findChecklistFieldById(
        formulaQ.questionId,
        formulaQ.groupId,
        checklist
      )
      const foundQuestion = formulaQuestion!.formula!.inputQuestions.find(
        (i) => i.questionId === inputQuestion.id
      )
      if (foundQuestion) {
        foundQuestion.questionValue = newInputQuestionAnswer
      }

      if (!newInputQuestionAnswer) {
        // deselect answer, we need to reset the formula questions
        formulaQuestion!.value = ''
        formulaQuestionsToRefresh.push(formulaQ)
      } else if (
        formulaQuestion!.formula!.inputQuestions.every(
          (i) => i.questionValue !== undefined && i.questionValue !== ''
        )
      ) {
        const inputQuestionsMap = new Map<number, string>()
        formulaQuestion!.formula!.inputQuestions.forEach((i) => {
          inputQuestionsMap.set(i.questionId, i.questionValue!)
        })

        const foundMatchingRows = false

        // all input questions are answered, lets set the answer for the formula question
        for (const row of formulaQuestion!.formula!.formulaRows) {
          const rowMatches = row.formulaRowItems.every(
            (rowItem: IFormulaRowItem) => {
              const actualValue = inputQuestionsMap.get(rowItem.questionId)

              return actualValue && actualValue === rowItem.value
            }
          )

          if (rowMatches) {
            // conditions are met, lets set the answer for formula question
            if (row.resultAnswer !== formulaQuestion!.value) {
              formulaQuestion!.value = row.resultAnswer

              formulaQuestionsToRefresh.push(formulaQ)
            }
            return
          }
        }
        if (!foundMatchingRows && formulaQuestion!.value) {
          // formula question was answered but input question changed, lets reset the answer

          formulaQuestion!.value = ''

          formulaQuestionsToRefresh.push(formulaQ)
        }
      }
    })
  }
  return formulaQuestionsToRefresh
}
